var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('RouterLink',{attrs:{"to":_vm.to}},[_c('RButton',{staticClass:"button",attrs:{"size":_vm.size,"fullWidth":_vm.fullWidth,"type":_vm.type}},[_vm._t("default"),_c('RIcon',{staticClass:"button-arrow",attrs:{"of":"ArrowLeft","viewBox":"2 2 20 20","stroke":_vm.stroke,"width":25,"height":25}})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }